module.exports = __webpack_public_path__ + "img/step-12.ef3d81fb.jpg";